<template>
    <div>
        <v-card class="black--text" color="white" width="100%">
            <v-toolbar color="amber" height="40">
                <v-btn icon @click="close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-bold body-2 text-uppercase black--text">{{orderDetail.productName}} > {{conditionType}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip label color="black" text-color="amber" small v-if="orderDetail.productNature != ''" class="caption font-weight-bold text-uppercase"> 
                        {{orderDetail.productNature}}
                    </v-chip>
            </v-toolbar>
            <!--<v-row class="mt-10 mx-0" >
                <v-col cols=12 md=4 sm=6>
                        <v-card class="cardShadow">
                            <div class="pa-2">
                                <p class="font-weight-light subtitle-1 ma-0">Demand rate: {{dRate}} /-</p>
                                <p class="font-weight-light subtitle-1 ma-0"> 
                                    <v-radio-group v-model="orderType" row >
                                        <v-radio label="FOR" color="amber" value="FOR"></v-radio>
                                        <v-radio label="EX" color="amber" value="EX"></v-radio>
                                    </v-radio-group>
                                </p>
                            </div>
                        </v-card>
                </v-col>
            </v-row>-->
            <v-card-text>
                <v-col cols=12 md=4 sm=6 class="py-0">
                    <!--<v-radio-group v-model="orderType" row >
                        <v-radio label="FOR" color="amber" value="FOR"></v-radio>
                        <v-radio label="EX" color="amber" value="EX"></v-radio>
                    </v-radio-group>-->
                </v-col>
                <v-row class="mx-0">
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="oQty" outlined color="amber" label="Qty / Tons" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="oRate" outlined color="amber" label="Rate / Qtl" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mx-0">
                    <v-col cols=12 md=6 sm=6 lg=6>
                        <v-text-field v-model="location" outlined color="amber" label="Location" dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols=12 md=6 sm=6 lg=6 v-if="orderType == 'EX'">
                        <v-text-field v-model="freight" outlined color="amber" label="Freight Charges / Qtl" dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-col cols=12 md=12 lg=12 sm=12 class="text-right">
                    <v-btn  color="amber" class="black--text" :loading="loading" @click="Save()">Save</v-btn>
                </v-col>
            </v-card-text>
        </v-card>
        <span style="display:none;">{{checkAndFetch}}</span>
    </div>
  
</template>

<script>
import { SERVER_API } from '../../API'
    export default {
        created(){
            window.addEventListener('keyup', event => {
                if(event.which === 27){
                    this.close();
                }
                if(event.which === 13){
                    this.Save();
                }
            })
        },
        data(){
            return{
                loading:false,
                orderDetail:[],
                dRate:'',
                orderType: 'EX',
                conditionType: '',
                freight:'',
                oQty:'',
                oRate:'',
                location:'',
            }
        },
        props:{
            updateid: {
                type: Number,
                required: true,
            },
            edit: {
                type: Boolean,
            },
            cond: {
                type: String,
                required: true,
            },
        },
        computed:{
            checkAndFetch(){
               return this.fetchedbyid();
            }
        },
        methods:{
            reset() {
                //this.orderType = 'FOR'; 
                //this.conditionType = '';
                this.oQty = '';
                this.oRate = '';
                this.location = '';
                this.freight = "";
            },
            close(){
                this.reset();
                this.$emit('close',false);
            },
            async fetchedbyid(){
                this.conditionType = this.cond;
                const Response = await this.$http.get(SERVER_API+'/dailyupdate/byid/'+this.updateid);
                this.orderDetail = Response.data.data;
                this.dRate = this.cond == 'pb/hr' ? this.orderDetail.looseRatePbHr : this.orderDetail.looseRateSumerpur;
                

            },
            async Save(){
                try{
                    this.loading = true;
                    const Response = await this.$http.post(SERVER_API+'/order/create',{
                        updateId:this.updateid,
                        dRate:this.dRate,
                        product: this.orderDetail.productId,
                        orderType: this.orderType,
                        conditionType: this.conditionType,
                        // Above Fixed
                        oQty: this.oQty,
                        oRate: this.oRate,
                        location:this.location,
                        freight:this.freight
                    });
                    this.loading = false;
                    this.reset();
                    this.$emit('Response', Response.data);
                }catch(error){
                    this.loading = false;
                    this.$emit('Response', error);
                }
            }
        }
    }
</script>
<style scoped>
.fixedBar{
    z-index: 99;
    height: 64px;
    position: fixed;
    width: 100%;
}
.mt-10{
    margin-top:80px !important;
}
</style>    